<template>
  <UIButton
    v-bind="{ size }"
    :leading="ArrowUpTrayIcon"
    label="Export"
    variant="gray"
    fill="light"
    hide-label-to-sm
  />
</template>

<script setup lang="ts">
import { inject } from 'vue'

import { ButtonSize } from '@types'

import { ArrowUpTrayIcon } from '@heroicons/vue/24/outline'

import { UIButton } from '@ui/buttons'

const size = inject<ButtonSize>('size')
</script>
